module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/ic-4-b97be7ed03fa740de812bde7d85885be.png";